import { $api } from './interceptor';
import { IContractFeeRow, ISwapFees, IUpdateContractFees } from '../types/fees';

const feesApi = () => {
  const getContractFees = async () => {
    const { data } = await $api.get<IContractFeeRow[]>(
      '/api/admin/fees/contracts'
    );
    return data;
  };

  const updateContractFees = async (id: string, patch: IUpdateContractFees) => {
    const { data } = await $api.patch<IContractFeeRow>(
      `/api/admin/fees/contracts/${id}`,
      patch
    );
    return data;
  };

  const getSwapFees = async () => {
    const { data } = await $api.get<ISwapFees>('/api/admin/fees/swap');
    return data;
  };

  const updateSwapFees = async (patch: ISwapFees) => {
    const { data } = await $api.patch<ISwapFees>('/api/admin/fees/swap', patch);
    return data;
  };

  return {
    getContractFees,
    updateContractFees,
    getSwapFees,
    updateSwapFees,
  };
};

export const feesService = feesApi();
